/**
 * Тип расхождения при приемке (справочник)
 */
class ComplaintType {
  public id:   string;
  public name: string | null;

  constructor(id: string, name: string | null = null) {
    this.id   = id;
    this.name = name;
  }

  static fromServer(data: any): ComplaintType {
    return new ComplaintType(data.id, data.name ?? null);
  }
}

export default ComplaintType;
